import { FilterScopeProvider, PlayerPageFilters, ResetAllFiltersButton } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { useMatch } from 'react-router-dom';
import { unwrappedPlayerComparisonPositionsOptionsAtom } from '@/atoms/filters/highLevel/comparisonPositions';
import {
  playerComparisonCompetitionOptionsAtom,
  playerComparisonSeasonOptionsAtom,
  playerComparisonTeamsOptionsAtom,
} from '@/atoms/filters/player/playerComparisonFilters';
import { playerComparisonGamesBySeasonAtom } from '@/atoms/filters/player/playerComparisonGames';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';
import { toGameSelectorGroups } from '@/utils/games';

const unwrappedCompetitionOptionsAtom = unwrap(playerComparisonCompetitionOptionsAtom, prev => prev ?? []);
const unwrappedSeasonOptionsAtom = unwrap(playerComparisonSeasonOptionsAtom, prev => prev ?? []);
const unwrappedTeamOptionsAtom = unwrap(playerComparisonTeamsOptionsAtom, prev => prev ?? []);
const unwrappedGamesBySeasonAtom = unwrap(playerComparisonGamesBySeasonAtom, prev => prev ?? []);

const PlayerComparisonFiltersContent = ({ comparisonId }: { comparisonId: number }) => {
  const competitionOptions = useAtomValue(unwrappedCompetitionOptionsAtom);
  const seasonOptions = useAtomValue(unwrappedSeasonOptionsAtom);
  const teamOptions = useAtomValue(unwrappedTeamOptionsAtom);
  const positionOptions = useAtomValue(unwrappedPlayerComparisonPositionsOptionsAtom);
  const gamesBySeason = useAtomValue(unwrappedGamesBySeasonAtom);
  const gamesGroupedBySeason = toGameSelectorGroups(gamesBySeason);
  const isPlayerVisPage = !!useMatch('/:locale/player/:playerId/vis/*');
  const isPlayerMatchesPage = !!useMatch('/:locale/player/:playerId/matches/*');
  const showTracking = usePhysicalMetricsFeature();

  return (
    <PlayerPageFilters
      competitionOptions={competitionOptions}
      gamesGroupedBySeason={gamesGroupedBySeason}
      headerActions={<ResetAllFiltersButton />}
      hideAttributes={!isPlayerVisPage}
      hidePitch={!isPlayerVisPage}
      hidePosition={isPlayerMatchesPage}
      playerId={comparisonId}
      positionOptions={positionOptions}
      seasonOptions={seasonOptions}
      showTabs={false}
      showTracking={showTracking}
      teamOptions={teamOptions}
    />
  );
};

export const PlayerComparisonHighLevelFilters = () => {
  const comparisonId = useAtomValue(comparisonIdAtom);

  if (!comparisonId) return null;

  return (
    <FilterScopeProvider scope="comparison">
      <PlayerComparisonFiltersContent comparisonId={comparisonId} />
    </FilterScopeProvider>
  );
};
